export default "__VITE_ASSET__BcxCC67D__"